import React from 'react';
import styled, { css } from 'styled-components';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import produce from 'immer';
import { RouteComponentProps, withRouter, NavLink } from 'react-router-dom';
import queryString from 'query-string';
import { debounce } from 'lodash';
import ReactGA from 'react-ga';

import { media } from '../common/Layout';

import SearchInputContainer from '../../containers/common/SearchInputContainer';

import { searchKeywordState } from '../../modules/searchKeyword';
import { GET_PATH_NETWORK_RECOMMEND_INFO } from '../../modules/tabAI';

import Logo from '../../assets/bi/aivory-bi-color@2x.png';
import IconOption from '../../assets/icon/ic-option@2x.png';
import {
  GetPatentParamType,
  GetRecommendedWordParamType,
} from '../../lib/tabAI/type';

import { tabImageState } from '../../modules/tabImage';
import { GetPathNetworkRecommendParamType2 } from '../../lib/tabAI/recommendType';

type StyledType = {
  isOptionSelect?: boolean;
  isOption?: boolean;
};

const NavigationComponent = styled.div`
  /* All Device */

  /* Mobile Device */
  padding-top: 17px;

  ${media.desktop`
    padding-top: 30px;
  `};
`;

const NavForm = styled.div`
  /* All Device */
  max-width: 1070px;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  margin-left: auto;
  margin-right: auto;

  /* Mobile Device */
  margin-bottom: 18px;
  padding-left: 16px;
  padding-right: 16px;

  ${media.desktop`
    flex-direction: row;
    margin-bottom: 55px;
    padding-left: 0px;
    padding-right: 0px;
  `};
`;

const LogoBox = styled.div`
  position: relative;
  display: flex;
  height: 32px;
  margin-bottom: 17px;
  cursor: pointer;
  ${media.desktop`
    position: absolute;
    left: -185px;
    margin-bottom: 0px;
  `};
`;

const LogoImg = styled.img`
  height: 32px;
`;

const TabForm = styled.div`
  /* All Device */
  width: 100%;
  border-bottom: solid 1px #cccccc;

  /* Mobile Device */
  padding-left: 16px;
  padding-right: 16px;

  ${media.desktop`
    padding-left: 0px;
    padding-right: 0px;
  `};
`;

const TabBox = styled.div`
  /* All Device */
  height: 100%;
  display: flex;
  align-items: flex-end;
  margin-left: auto;
  margin-right: auto;

  /* Mobile Device */
  max-width: 1000px;
  justify-content: space-between;

  ${media.desktop`
    max-width: 1070px;
    justify-content: flex-start;
  `};
`;

const TabGroup = styled.div`
  align-items: flex-end;
  display: flex;
  height: 100%;

  min-width: 350px;
  ${media.desktop`
    width: 690px;
  `};
`;

const TabItem = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  margin-right: 40px;
`;

const TabTitle = styled(NavLink)`
  font-family: 'NotoKrR';
  display: flex;
  justify-content: center;
  height: 20px;
  margin-bottom: 11px;
  color: #555555;
  cursor: pointer;
  &.active {
    font-family: 'NotoKrM';
    color: #000000;
  }

  /* Mobile Device */
  font-size: 13px;

  ${media.desktop`
    font-size: 14px;
  `};
`;

const TabHighlight = styled(NavLink)`
  width: 60px;
  height: 4px;
  background-color: white;
  position: absolute;
  transform: -50%;
  bottom: 0px;
  &.active {
    background-color: #1f88e5;
  }
`;

const OptionGroup = styled.div`
  align-items: flex-end;
  display: flex;
  height: 100%;

  ${media.desktop`
    width: 320px;
    margin-left: 60px;
  `};
  &.active {
    display: none;
  }
  ${(props: StyledType) => {
    if (!props.isOption) {
      return css`
        display: none;
      `;
    }
    return css``;
  }}
`;

const OptionBox = styled(Dropdown)`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

const OptionToggle = styled(DropdownToggle)`
  /* All Device */
  display: flex;
  background-color: transparent;
  border: none;

  /* Mobile Device */
  padding-right: 0px;

  ${media.desktop`
    padding-right: 0.75rem;
  `};

  :hover {
    background-color: transparent;
    border: none;
    color: #555555;
  }
  :focus {
    background-color: transparent;
    border: none;
    color: #555555;
    outline: none;
    box-shadow: none;
  }
`;

const OptionIcon = styled.img`
  height: 16px;
`;

const OptionText = styled.div`
  font-family: 'NotoKrR';
  margin-left: 6.4px;
  font-size: 14px;
  font-weight: normal;
  color: #555555;
  background-color: transparent;
  border: none;

  display: none;

  ${media.desktop`
    display: flex;
  `};

  :hover {
    background-color: transparent;
    border: none;
    color: #555555;
  }
  :focus {
    background-color: transparent;
    border: none;
    color: #555555;
    outline: none;
    box-shadow: none;
  }
`;

const OptionModal = styled(DropdownMenu)`
  /* All Device */
  position: absolute;
  border-radius: 8px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: white;

  /* Mobile Device */
  right: 0px !important;
  left: auto;
  top: 30px;
  width: 150px;
  padding: 12px;

  ${media.desktop` 
    left: 0px;
    top: 30px;
    width: 180px;
    padding: 20px;
  `};
  :focus {
    outline: none;
  }
`;

const OptionItemBox = styled.div`
  display: flex;
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0px;
  }
  /* align-items: center; */
`;
const OptionItemTitle = styled.div`
  font-family: 'NotoKrM';
  display: flex;
  align-items: center;
  height: 20px;
  color: #555555;

  /* Mobile Device */
  font-size: 12px;

  ${media.desktop` 
    font-size: 14px;
  `};
`;
const OptionItemSplit = styled.div`
  width: 0;
  height: 13px;
  border: solid 1px #e1e6f0;
  margin-left: 10px;
`;
const OptionItemDescList = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;
const OptionItemListItem = styled.div`
  font-family: 'NotoKrL';
  height: 20px;
  margin-bottom: 10px;
  color: #555555;
  cursor: pointer;
  &:last-child {
    margin-bottom: 0px;
  }
  ${(props: StyledType) => {
    if (props.isOptionSelect) {
      return css`
        font-family: 'NotoKrM';
        border-bottom: 1px solid black;
        width: fit-content;
        color: black;
      `;
    }
    return css``;
  }}

  /* Mobile Device */
  font-size: 12px;

  ${media.desktop` 
    font-size: 14px;
  `};
`;
interface NavigationProps extends RouteComponentProps {
  selectedMenuId: number;
  searchKeyword: searchKeywordState['searchKeyword'];

  onGoToResult: (q: string | string[]) => void;
  onGoToAI: (q: string | string[]) => void;
  onGoToImage: (q: string | string[]) => void;
  onGoToSimilarImage: (q: string | string[]) => void;
  onSetSearchKeyword: (
    searchKeyword: searchKeywordState['searchKeyword']
  ) => void;
  onGetPathNetwork: (info: GET_PATH_NETWORK_RECOMMEND_INFO) => void;
  onGetPatent: (info: GetPatentParamType) => void;
  onGetRecommendedWord: (info: GetRecommendedWordParamType) => void;

  onSetAddImage: (addImageData: tabImageState['addImageData']) => void;
  onGetPathNetwork2: (info: GetPathNetworkRecommendParamType2) => void;
  onSetSearchDataNull: () => void;
  onSetAIDataNull: () => void;
  onSetImageDataNull: () => void;
  onResultTabDataSet: (q: string | string[]) => void;
  onAITabDataSet: (q: string | string[]) => void;
  onImageDataSet: (q: string | string[]) => void;
  onClickResult: (q: string | string[]) => void;
  onClickAI: (q: string | string[]) => void;
  onClickImage: (q: string | string[]) => void;
  onClickSimilarImage: (q: string | string[]) => void;
}

type NavigationState = {
  optionSort: {
    id: number;
    text: string;
    active: boolean;
  }[];
  optionResult: {
    id: number;
    text: string;
    active: boolean;
    param: string;
  }[];
  optionDate: {
    id: number;
    text: string;
    active: boolean;
  }[];
  isOption: boolean;
  isDropdownOpen: boolean;
  urlState: string;
};

function isString(val: string | string[]): val is string {
  return typeof val === 'string';
}

function NOW(year: number, month: number, day: number) {
  const date = new Date();
  const aaaa = date.getFullYear() - year;
  const gg = date.getDate() - day;
  const mm = date.getMonth() + 1 - month;

  let ggString = `${gg}`;
  let mmString = `${mm}`;

  if (gg < 10) ggString = `0${gg}`;

  if (mm < 10) mmString = `0${mm}`;

  const cur_day = `${aaaa}-${mmString}-${ggString}`;

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  let hoursString = `${hours}`;
  let minutesString = `${minutes}`;
  let secondsString = `${seconds}`;

  if (hours < 10) hoursString = `0${hours}`;

  if (minutes < 10) minutesString = `0${minutes}`;

  if (seconds < 10) secondsString = `0${seconds}`;

  return `${cur_day} ${hoursString}:${minutesString}:${secondsString}`;
}

class Navigation extends React.PureComponent<NavigationProps, NavigationState> {
  menuId: number;

  tabUrl: string;

  constructor(props: NavigationProps) {
    super(props);
    this.state = {
      isOption: false,
      isDropdownOpen: false,
      optionSort: [
        { id: 0, text: '정확도순', active: true },
        { id: 1, text: '최신순', active: false },
      ],
      optionResult: [
        { id: 0, text: '완전일치', active: false, param: 'full_match' },
        {
          id: 1,
          text: '부분일치(and)',
          active: true,
          param: 'partial_match_and',
        },
        {
          id: 2,
          text: '부분일치(or)',
          active: false,
          param: 'partial_match_or',
        },
      ],
      optionDate: [
        { id: 0, text: '전체', active: true },
        { id: 1, text: '최근1일', active: false },
        { id: 2, text: '최근1주', active: false },
        { id: 3, text: '최근1개월', active: false },
        { id: 4, text: '최근6개월', active: false },
        { id: 5, text: '최근1년', active: false },
      ],
      urlState: 'result',
    };

    this.menuId = 0;
    this.tabUrl = 'result';
  }

  componentDidMount() {
    const {
      onResultTabDataSet,
      onAITabDataSet,
      onImageDataSet,
      location,
    } = this.props;

    localStorage.setItem('aivory_option_sort', '0');
    localStorage.setItem('aivory_option_result', 'partial_match_and');
    localStorage.setItem('aivory_option_date_start', '');
    localStorage.setItem('aivory_option_date_end', NOW(0, 0, 0));

    const query = queryString.parse(location.search);
    let keyword: string | string[] = '';

    if (query.q) {
      if (isString(query.q)) {
        keyword = query.q;
      } else {
        const index = 0;
        keyword = query.q[index];
      }
    }

    if (keyword) {
      switch (location.pathname) {
        case '/search/result':
          onResultTabDataSet(keyword);
          this.setState({
            isOption: true,
          });
          this.tabUrl = 'result';
          break;
        case '/search/ai':
          onAITabDataSet(keyword);
          this.setState({
            isOption: false,
          });
          this.tabUrl = 'ai';
          break;
        case '/search/image':
          onImageDataSet(keyword);
          this.setState({
            isOption: true,
          });
          this.tabUrl = 'image';
          break;
        case '/search/similarImage':
          // onImageDataSet(keyword);
          this.setState({
            isOption: false,
          });
          this.tabUrl = 'similarImage';
          break;
        default:
          break;
      }
    }

    this.historyListener();
  }

  // shouldComponentUpdate(
  //   nextProps: NavigationProps,
  //   nextState: NavigationState
  // ) {
  //   const { searchKeyword, history } = this.props;
  //   const {
  //     optionDate,
  //     optionResult,
  //     optionSort,
  //     isDropdownOpen,
  //     urlState,
  //   } = this.state;

  //   if (nextProps.history !== history) {
  //     return true;
  //   }
  //   if (nextState.optionDate !== optionDate) {
  //     return true;
  //   }
  //   if (nextState.optionResult !== optionResult) {
  //     return true;
  //   }
  //   if (nextState.optionSort !== optionSort) {
  //     return true;
  //   }
  //   if (nextState.isDropdownOpen !== isDropdownOpen) {
  //     return true;
  //   }
  //   if (nextProps.searchKeyword !== searchKeyword) {
  //     return true;
  //   }
  //   if (nextState.urlState !== urlState) {
  //     return true;
  //   }

  //   return true;
  // }

  historyListener = () => {
    const { history } = this.props;

    history.listen((element) => {
      if (element.action === 'POP') {
        window.location.reload(true);
      }
    });
  };

  setLocalStorage = (keyword: any) => {
    const searchList = localStorage.getItem('aivorySearchList');

    if (searchList) {
      const arr = JSON.parse(searchList);
      const isFind = arr.indexOf(keyword);
      if (isFind === -1) {
        arr.push(keyword);
        localStorage.setItem('aivorySearchList', JSON.stringify(arr));
      }
    } else {
      localStorage.setItem('aivorySearchList', JSON.stringify([keyword]));
    }
  };

  WhichTabSearching = debounce((tabId: number) => {
    const {
      onGoToAI,
      onGoToImage,
      onGoToResult,
      onGoToSimilarImage,
      searchKeyword,
    } = this.props;
    this.setLocalStorage(searchKeyword);

    switch (tabId) {
      case 0:
        this.tabUrl = 'result';
        this.setState({
          urlState: 'result',
          isOption: true,
        });
        onGoToResult(searchKeyword);
        break;
      case 1:
        this.tabUrl = 'ai';
        this.setState({
          urlState: 'ai',
          isOption: false,
        });
        onGoToAI(searchKeyword);
        break;
      case 2:
        this.tabUrl = 'image';
        this.setState({
          urlState: 'image',
          isOption: true,
        });
        onGoToImage(searchKeyword);
        break;
      case 3:
        this.tabUrl = 'similarImage';
        this.setState({
          urlState: 'similarImage',
        });
        onGoToSimilarImage(searchKeyword);
        break;
      default:
        this.tabUrl = 'result';
        this.setState({
          urlState: 'result',
        });
        onGoToResult(searchKeyword);
        break;
    }
  }, 100);

  WhichTabClick = debounce((tabId: number) => {
    const {
      onClickAI,
      onClickImage,
      onClickResult,
      onClickSimilarImage,
      searchKeyword,
    } = this.props;
    this.setLocalStorage(searchKeyword);

    switch (tabId) {
      case 0:
        this.tabUrl = 'result';
        this.setState({
          urlState: 'result',
          isOption: true,
        });
        onClickResult(searchKeyword);
        break;
      case 1:
        this.tabUrl = 'ai';
        this.setState({
          urlState: 'ai',
          isOption: false,
        });
        onClickAI(searchKeyword);
        break;
      case 2:
        this.tabUrl = 'image';
        this.setState({
          urlState: 'image',
          isOption: true,
        });
        onClickImage(searchKeyword);
        break;
      case 3:
        this.tabUrl = 'similarImage';
        this.setState({
          urlState: 'similarImage',
        });
        onClickSimilarImage(searchKeyword);
        break;
      default:
        this.tabUrl = 'result';
        this.setState({
          urlState: 'result',
        });
        onClickResult(searchKeyword);
        break;
    }
  }, 100);

  onClickTab = (selectedNumber: number) => {
    this.WhichTabClick(selectedNumber);

    switch (selectedNumber) {
      case 0:
        ReactGA.ga('send', 'event', `click_search_result_tab_button`);
        break;
      case 1:
        ReactGA.ga('send', 'event', `click_search_ai_tab_button`);
        break;
      case 2:
        ReactGA.ga('send', 'event', `click_search_image_tab_button`);
        break;
      case 3:
        ReactGA.ga('send', 'event', `click_search_similar_image_tab_button`);
        break;
      default:
        break;
    }
  };

  onClickOptionSort = (selectId: number) => {
    this.setState(
      produce((draft: NavigationState) => {
        draft.optionSort.forEach((element) => {
          const tempElement = element;
          if (element.id === selectId) {
            tempElement.active = true;
            localStorage.setItem('aivory_option_sort', `${element.id}`);
            if (this.tabUrl === 'result') {
              this.WhichTabSearching(0);
            } else {
              this.WhichTabSearching(2);
            }
          } else {
            tempElement.active = false;
          }
        });
      })
    );
  };

  onClickOptionResult = (selectId: number) => {
    this.setState(
      produce((draft: NavigationState) => {
        draft.optionResult.forEach((element) => {
          const tempElement = element;
          if (element.id === selectId) {
            tempElement.active = true;
            localStorage.setItem('aivory_option_result', element.param);
            if (this.tabUrl === 'result') {
              this.WhichTabSearching(0);
            } else {
              this.WhichTabSearching(2);
            }
          } else {
            tempElement.active = false;
          }
        });
      })
    );
  };

  onClickOptionDate = (selectId: number) => {
    this.setState(
      produce((draft: NavigationState) => {
        draft.optionDate.forEach((element) => {
          const tempElement = element;
          if (element.id === selectId) {
            tempElement.active = true;
            switch (selectId) {
              case 0:
                localStorage.setItem('aivory_option_date_start', '');
                break;
              case 1:
                localStorage.setItem('aivory_option_date_start', NOW(0, 0, 1));
                break;
              case 2:
                localStorage.setItem('aivory_option_date_start', NOW(0, 0, 7));
                break;
              case 3:
                localStorage.setItem('aivory_option_date_start', NOW(0, 1, 0));
                break;
              case 4:
                localStorage.setItem('aivory_option_date_start', NOW(0, 6, 0));
                break;
              case 5:
                localStorage.setItem('aivory_option_date_start', NOW(1, 0, 0));
                break;
              default:
                break;
            }
            if (this.tabUrl === 'result') {
              this.WhichTabSearching(0);
            } else {
              this.WhichTabSearching(2);
            }
          } else {
            tempElement.active = false;
          }
        });
      })
    );
  };

  dropDownToggle = () => {
    const { isDropdownOpen } = this.state;
    this.setState({
      isDropdownOpen: !isDropdownOpen,
    });
  };

  render() {
    const {
      optionDate,
      optionResult,
      optionSort,
      isDropdownOpen,
      urlState,
      isOption,
    } = this.state;
    const { history } = this.props;

    return (
      <NavigationComponent>
        <NavForm>
          <LogoBox
            onClick={() => {
              ReactGA.ga('send', 'event', `click_search_bi_button`);
              history.push('/');
              window.location.reload(true);
            }}
          >
            <LogoImg src={Logo} alt="aivory logo" />
          </LogoBox>
          <SearchInputContainer urlParam={urlState} />
        </NavForm>
        <TabForm>
          <TabBox>
            <TabGroup>
              <TabItem>
                <TabTitle
                  id="aivory-tab-result"
                  onClick={() => {
                    this.onClickTab(0);
                  }}
                  exact
                  to="/search/result"
                >
                  검색결과
                </TabTitle>
                <TabHighlight exact to="/search/result" />
              </TabItem>
              <TabItem>
                <TabTitle
                  onClick={() => {
                    this.onClickTab(1);
                  }}
                  exact
                  to="/search/ai"
                >
                  AI추천
                </TabTitle>
                <TabHighlight exact to="/search/ai" />
              </TabItem>
              <TabItem>
                <TabTitle
                  id="aivory-tab-image"
                  onClick={() => {
                    this.onClickTab(2);
                  }}
                  exact
                  to="/search/image"
                >
                  이미지
                </TabTitle>
                <TabHighlight exact to="/search/image" />
              </TabItem>
              <TabItem>
                <TabTitle
                  id="aivory-tab-similarImage"
                  onClick={() => {
                    this.onClickTab(3);
                  }}
                  exact
                  to="/search/similarImage"
                >
                  이미지 검색
                </TabTitle>
                <TabHighlight exact to="/search/similarImage" />
              </TabItem>
            </TabGroup>
            <OptionGroup isOption={isOption}>
              <OptionBox isOpen={isDropdownOpen} toggle={this.dropDownToggle}>
                <OptionToggle
                  onClick={() => {
                    ReactGA.ga('send', 'event', `click_search_option_button`);
                  }}
                >
                  <OptionIcon src={IconOption} />
                  <OptionText>검색옵션</OptionText>
                </OptionToggle>

                <OptionModal>
                  <OptionItemBox>
                    <OptionItemTitle>
                      정렬
                      <OptionItemSplit />
                    </OptionItemTitle>
                    <OptionItemDescList>
                      <OptionItemListItem
                        onClick={() => {
                          ReactGA.ga(
                            'send',
                            'event',
                            `click_search_option_list_정확도순_button`
                          );
                          this.onClickOptionSort(0);
                        }}
                        isOptionSelect={optionSort[0].active}
                      >
                        정확도순
                      </OptionItemListItem>
                      <OptionItemListItem
                        onClick={() => {
                          ReactGA.ga(
                            'send',
                            'event',
                            `click_search_option_list_최신순_button`
                          );
                          this.onClickOptionSort(1);
                        }}
                        isOptionSelect={optionSort[1].active}
                      >
                        최신순
                      </OptionItemListItem>
                    </OptionItemDescList>
                  </OptionItemBox>
                  <OptionItemBox>
                    <OptionItemTitle>
                      결과
                      <OptionItemSplit />
                    </OptionItemTitle>
                    <OptionItemDescList>
                      {/* <OptionItemListItem
                        onClick={() => {
                          this.onClickOptionResult(0);
                        }}
                        isOptionSelect={optionResult[0].active}
                      >
                        전체
                      </OptionItemListItem> */}
                      <OptionItemListItem
                        onClick={() => {
                          ReactGA.ga(
                            'send',
                            'event',
                            `click_search_option_list_부분일치(and)_button`
                          );
                          this.onClickOptionResult(1);
                        }}
                        isOptionSelect={optionResult[1].active}
                      >
                        부분일치(and)
                      </OptionItemListItem>
                      <OptionItemListItem
                        onClick={() => {
                          ReactGA.ga(
                            'send',
                            'event',
                            `click_search_option_list_부분일치(or)_button`
                          );
                          this.onClickOptionResult(2);
                        }}
                        isOptionSelect={optionResult[2].active}
                      >
                        부분일치(or)
                      </OptionItemListItem>
                      <OptionItemListItem
                        onClick={() => {
                          ReactGA.ga(
                            'send',
                            'event',
                            `click_search_option_list_완전일치_button`
                          );
                          this.onClickOptionResult(0);
                        }}
                        isOptionSelect={optionResult[0].active}
                      >
                        완전일치
                      </OptionItemListItem>
                    </OptionItemDescList>
                  </OptionItemBox>
                  <OptionItemBox>
                    <OptionItemTitle>
                      기간
                      <OptionItemSplit />
                    </OptionItemTitle>
                    <OptionItemDescList>
                      <OptionItemListItem
                        onClick={() => {
                          ReactGA.ga(
                            'send',
                            'event',
                            `click_search_option_list_기간_전체_button`
                          );
                          this.onClickOptionDate(0);
                        }}
                        isOptionSelect={optionDate[0].active}
                      >
                        전체
                      </OptionItemListItem>
                      <OptionItemListItem
                        onClick={() => {
                          ReactGA.ga(
                            'send',
                            'event',
                            `click_search_option_list_기간_최근1일_button`
                          );
                          this.onClickOptionDate(1);
                        }}
                        isOptionSelect={optionDate[1].active}
                      >
                        최근 1일
                      </OptionItemListItem>
                      <OptionItemListItem
                        onClick={() => {
                          ReactGA.ga(
                            'send',
                            'event',
                            `click_search_option_list_기간_최근1주_button`
                          );
                          this.onClickOptionDate(2);
                        }}
                        isOptionSelect={optionDate[2].active}
                      >
                        최근 1주
                      </OptionItemListItem>
                      <OptionItemListItem
                        onClick={() => {
                          ReactGA.ga(
                            'send',
                            'event',
                            `click_search_option_list_기간_최근1개월_button`
                          );
                          this.onClickOptionDate(3);
                        }}
                        isOptionSelect={optionDate[3].active}
                      >
                        최근 1개월
                      </OptionItemListItem>
                      <OptionItemListItem
                        onClick={() => {
                          ReactGA.ga(
                            'send',
                            'event',
                            `click_search_option_list_기간_최근6개월_button`
                          );
                          this.onClickOptionDate(4);
                        }}
                        isOptionSelect={optionDate[4].active}
                      >
                        최근 6개월
                      </OptionItemListItem>
                      <OptionItemListItem
                        onClick={() => {
                          ReactGA.ga(
                            'send',
                            'event',
                            `click_search_option_list_기간_최근1년_button`
                          );
                          this.onClickOptionDate(5);
                        }}
                        isOptionSelect={optionDate[5].active}
                      >
                        최근 1년
                      </OptionItemListItem>
                    </OptionItemDescList>
                  </OptionItemBox>
                </OptionModal>
              </OptionBox>
            </OptionGroup>
          </TabBox>
        </TabForm>
      </NavigationComponent>
    );
  }
}

export default withRouter(Navigation);
